"use client";

import React, { useState, useCallback, FC } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { RichTextBlock } from "../rich-text-block/component";

import { ABOUT_CLASSES } from "./constants";
import { AboutContainer } from "./styled";
import { AboutProps } from "./types";

export const About: FC<AboutProps> = ({ store, aboutText, showMoreText }) => {
  const [isFullTextVisible, setIsFullTextVisible] = useState(false);

  const shortText = store?.description?.slice(
    0,
    store?.description?.indexOf(" ", 150),
  );

  const toggleVisible = useCallback(
    () => setIsFullTextVisible(!isFullTextVisible),
    [isFullTextVisible],
  );

  if (!store?.description && !store?.descriptionMarkdown) {
    return null;
  }

  const descriptionContent = store?.descriptionMarkdown ? (
    <RichTextBlock text={store?.descriptionMarkdown} />
  ) : isFullTextVisible ? (
    <Typography
      variant="body1"
      className={ABOUT_CLASSES.text}
      {...getTestAutomationProps("text")}
    >
      {store.description}
    </Typography>
  ) : (
    <Typography
      variant="body1"
      className={ABOUT_CLASSES.text}
      {...getTestAutomationProps("short-text")}
    >
      {`${shortText} ... `}
      <Box
        component="span"
        className={ABOUT_CLASSES.showMore}
        onClick={toggleVisible}
      >
        {showMoreText}
      </Box>
    </Typography>
  );

  return (
    <AboutContainer {...getTestAutomationProps("about")}>
      <Grid container>
        <Grid item md={3} className={ABOUT_CLASSES.hideOnMobile} />
        <Grid item xs={12} md={6}>
          <Typography
            variant="h4"
            className={ABOUT_CLASSES.title}
            {...getTestAutomationProps("title")}
          >
            {aboutText} {store?.geomodifier}
          </Typography>
          {descriptionContent}
        </Grid>
        <Grid item md={3} className={ABOUT_CLASSES.hideOnMobile} />
      </Grid>
    </AboutContainer>
  );
};
